module.exports = require("tls");


//////////////////
// WEBPACK FOOTER
// external "tls"
// module id = 75
// module chunks = 0